// frontend/src/presentation/context/networkSync.ts
//
// Kontekst Silnika Synchronizacji — udostępnia JEDNĄ instancję stanu z
// `useNetworkSync` całemu drzewu komponentów. Dzięki temu `processQueue`
// (opróżnianie kolejki offline) działa jako pojedynczy singleton w tle:
// ekrany konsumują `triggerSync` / `isOnline` / `isSyncing` przez ten kontekst,
// zamiast każdy wołać `useNetworkSync` osobno (co powoływało wiele niezależnych
// serwisów i nasłuchów 'online' → zdublowana wysyłka / wyścigi).
//
// Plik celowo bez komponentu (osobno: `NetworkSyncProvider.tsx`) — trzyma tylko
// obiekt kontekstu i hak konsumenta.

import { createContext, useContext } from 'react'

import type { NetworkSyncState } from '../hooks/useNetworkSync'

/** Wartość kontekstu; `null` dopóki drzewa nie obejmie `NetworkSyncProvider`. */
export const NetworkSyncContext = createContext<NetworkSyncState | null>(null)

/**
 * Zwraca współdzielony stan Silnika Synchronizacji.
 * Rzuca, gdy użyty poza `NetworkSyncProvider` — brak providera oznaczałby, że
 * komponent tworzy własny, niesingletonowy tor synchronizacji (dokładnie to,
 * czego ten kontekst ma unikać).
 */
export function useNetworkSyncContext(): NetworkSyncState {
  const ctx = useContext(NetworkSyncContext)
  if (ctx === null) {
    throw new Error('useNetworkSyncContext musi być użyty wewnątrz <NetworkSyncProvider>.')
  }
  return ctx
}
